<template>
  <div>
    <div style="margin-top: 15px;"><!-- display: flex;justify-content: space-between; -->
      <div>
        <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick">
          <el-tab-pane :label='$t("driver.总览")' name="fourth">
            <summy></summy>
          </el-tab-pane>
          <el-tab-pane :label='$t("statistics.日燃耗")' name="second">
            <dMConspt :activeName="activeName" :Init="dayInit" :type="'1'"></dMConspt>
          </el-tab-pane>
          <el-tab-pane :label='$t("statistics.月燃耗")' name="first">
            <dMConspt :activeName="activeName" :Init="monthInit" :type="'0'"></dMConspt>
          </el-tab-pane>
          <el-tab-pane :label='$t("statistics.年燃耗")' name="third">
            <dMConspt :activeName="activeName" :Init="yearInit" :type="'2'"></dMConspt>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

  </div>
</template>

<script>
// import * as echarts from "echarts"
import { mapState } from 'vuex'

import dMConspt from '@/views/statistics/energyConspt/dMConspt.vue'
import summy from './summy.vue'
export default {
  name: "energyConspt",
  components: { dMConspt, summy },
  data() {
    return {
      activeName: "fourth",
      dayInit: false,
      monthInit: false,
      yearInit: false,
    }
  },
  computed: {

  },
  watch: {

  },
  methods: {
    handleClick(tabs) {
      const { index } = tabs;
      console.log(index);
      switch (index) {
        case "0":
          break;
        case "1":
          this.dayInit = true;
          break;
        case "2":
          this.monthInit = true;
          break;
        case "3":
          this.yearInit = true;
          break;
      }
    },
  },
  created() {

  },
  mounted() {

  },
  destroyed() {
  },
}
</script>

<style lang="scss" scoped>
.el-card {
  background-color: transparent;
}

.pagination {

  ::v-deep .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background-color: transparent !important;
  }

}

.container {
  :deep(.el-table tr) {
    background: transparent;
  }

  :deep(.el-table) {
    background: transparent;
  }

  ::v-deep .el-table td {
    background: transparent;
  }
}

.iconfont {
  font-size: 10px;
}

.foldBtn {
  ::v-deep .el-button--mini {
    padding: 5px 10px !important;
  }
}

.pcVal {
  font-size: 15px;
  font-weight: bold;
}

.comptVal {
  font-size: 24px;
  margin-right: 5px;
  font-weight: bold;
}

.card {
  ::v-deep .el-card__header {
    /* background: #E8F0FF; */
    /* height: 35px; */
    padding: 15px 9px;
    /* font-weight: bold; */
    font-size: 14px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

}

.el-icon-top:before {
  color: red;
  font-size: 24px;
  font-weight: bold;
}


.el-range-editor.el-input__inner {
  padding: 3px 5px;
}

.tabs {
  ::v-deep .el-tabs__item {
    padding: 0 10px !important;
    font-weight: bold;
    font-size: 14px;
  }

  ::v-deep .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }

  ::v-deep .el-tabs__header {
    margin: 0;
  }

  ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px;
  }
}

.el-form-item {
  margin-bottom: 0px !important;
}
</style>